import {
  CardPaymentServices,
  CartFulfillServices,
  CartQuoteServices,
  CartUpdateServices,
  ContactInformationServices,
  PassengerServices,
  TravelerServices,
  getObjectKeysAsObject,
  ReviewServices,
} from "@hopper-b2b/checkout";

export const Services = {
  ...CartFulfillServices,
  ...CartQuoteServices,
  ...CartUpdateServices,
  ...ContactInformationServices,
  ...PassengerServices,
  ...CardPaymentServices,
  ...TravelerServices,
  ...ReviewServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
